export default "__VITE_ASSET__t0iCF4kp__"